import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './Sidebar';
import Header from './Header';
import { useApp } from '../../contexts/AppContext';

const { Content } = Layout;

const MainLayout: React.FC = () => {
  const { state } = useApp();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar collapsed={state.sidebarCollapsed} />
      <Layout
        style={{
          marginLeft: state.sidebarCollapsed ? 80 : 240,
          transition: 'all 0.2s',
        }}
      >
        <Header />
        <Content
          style={{
            marginTop: 64,
            padding: 24,
            background: '#f5f5f5',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;